import { render } from "./create.vue?vue&type=template&id=e8e35918"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/parts/create.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e8e35918"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e8e35918', __exports__)) {
    console.log('reload')
    api.reload('e8e35918', __exports__)
  }
  
  module.hot.accept("./create.vue?vue&type=template&id=e8e35918", () => {
    console.log('re-render')
    api.rerender('e8e35918', render)
  })

}


export default __exports__